<template>
  <div class="container">
    <nyTit pathUrl='/nyhongshu' />
    <div class="nr_txt">
      <div class="nr_txt_t" @click="clickHref('/nyhongshu')">
        <dv-border-box-8 class="jz">
          <div class="txt_t_bt_bg">
            <h5>数字农业</h5>
          </div>
        </dv-border-box-8>
      </div>

      <div class="nr_txt_t" @click="clickHref('/suyuan')">
        <dv-border-box-8 class="jz">
          <div class="txt_t_bt_bg">
            <h5>质量农业</h5>
          </div>
        </dv-border-box-8>
      </div>

      <div class="nr_txt_t" @click="clickHref('/nongye1')">
        <dv-border-box-8 class="jz">
          <div class="txt_t_bt_bg">
            <h5>高标农业</h5>
          </div>
        </dv-border-box-8>
      </div>
    </div>
  </div>
</template>

<script setup>
import nyTit from '@/components/nyTit'
import { useRouter } from "vue-router";
const router = useRouter();
function clickHref(path){
  router.push(path)
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  background: url("../assets/img/gbsy/bj.png") no-repeat top center;
  background-size: 100% 100%;
  color: #fff;
  margin: 0 auto;
  .nr_txt {
    width: 4233px;
    height: 886px;
    // border: #fff 1px solid;
    position: absolute;
    top: 419px;
    left: 50%;
    margin-left: calc(-1 * 3633px / 2);
    display: flex;
    .nr_txt_t {
      width: 815px;
      height: 886px;
      margin: 0 300px;
      background: url("../assets/img/gbsy/k.png") no-repeat top center;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .txt_t_bt_bg {
        width: 440px;
        height: 510px;
        background: url("../assets/img/gbsy/ny.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        margin-left: calc(-1 * 440px / 2);
        top: 195px;

        h5 {
          font-size: 36px;
          color: #fff;
          text-align: center;
          margin-top: 350px;
        }
      }
    }
  }
}
</style>
